import { useEffect, useRef, useState } from "react"

import { useTranslation } from "react-i18next"

import Button from "../../../../../../../Components/Button"
import Input from "../../../../../../../Components/Input"

import chipStyles from "../../chips.module.less"

// The add affordance both chip lists use: a chip-shaped button that morphs into a text
// input on click, commits the trimmed value on Enter or blur, and morphs back. Owns the
// draft so callers only see finished values.
//
// `emptyChars` sizes the input before anything is typed — chip-multi wants a stub, while
// text-multi sizes to its placeholder so a full example descriptor stays visible.
const InlineChipInput = ({ addLabel, placeholder, minWidth = 80, emptyChars = 6, onCommit }) => {
  const { t } = useTranslation()
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState("")
  const inputRef = useRef(null)

  useEffect(() => {
    if (editing && inputRef.current) inputRef.current.focus()
  }, [editing])

  const commit = () => {
    const v = (draft || "").trim()
    if (v) onCommit(v)
    setDraft("")
    setEditing(false)
  }

  // Measure the draft so the input grows with the typed text and feels like a chip
  // morphing rather than a fixed-width form field.
  const width = Math.max(minWidth, (draft?.length || emptyChars) * 8 + 32)

  return editing ? (
    <Input
      ref={inputRef}
      value={draft}
      placeholder={placeholder || t("Type and press Enter")}
      onChange={(e) => setDraft(e.target.value)}
      onPressEnter={commit}
      onBlur={commit}
      className={`${chipStyles.chip} ${chipStyles.chipInput}`}
      style={{ width }}
    />
  ) : (
    <Button
      type="default"
      className={`${chipStyles.chip} ${chipStyles.chipAdd}`}
      onClick={() => setEditing(true)}
      text={addLabel}
    />
  )
}

export default InlineChipInput
